import { safeLocalStorage } from "@/lib/safeStorage";

function getSessionId(): string {
  const key = "analytics_session_id";
  let id = safeLocalStorage.getItem(key);
  if (!id) {
    id = crypto.randomUUID();
    safeLocalStorage.setItem(key, id);
  }
  return id;
}

async function sendToApi(payload: Record<string, unknown>) {
  try {
    await fetch("/.netlify/functions/api-page-view", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    });
  } catch (error) {
    // Silently ignore analytics errors in production
  }
}

export const trackEvent = (_eventName: string, _properties: Record<string, string | number | boolean | null> = {}) => {
};

export const trackPageView = (_path: string) => {
  const path = typeof window !== "undefined" ? window.location.pathname + window.location.search : _path;

  sendToApi({
    path,
    title: typeof document !== "undefined" ? document.title : null,
    referrer: typeof document !== "undefined" ? document.referrer || null : null,
    sessionId: getSessionId(),
    screenWidth: typeof window !== "undefined" ? window.screen.width : null,
    screenHeight: typeof window !== "undefined" ? window.screen.height : null,
    userAgent: typeof navigator !== "undefined" ? navigator.userAgent : null,
  });
};

export const captureContactFormSubmit = (properties: Record<string, string | number | boolean | null> = {}) => {
  sendToApi({
    name: properties.name || "",
    email: properties.email || "",
    subject: properties.subject || "",
    message: properties.message || "",
    sessionId: getSessionId(),
  });
};
